<template>
	<div>
		<apeiron-product-detail
			v-bind="payload"
			v-if="['apeiron_uat', 'apeiron'].includes($store.state.tenantId)"
		/>
		<default-product-detail v-bind="payload" v-else />
	</div>
</template>

<script>
import DefaultProductDetail from "../components/DefaultProductDetail"
import ApeironProductDetail from "../components/mockedApeiron/ApeironProductDetail"

export default {
	props: {
		plan: { type: String, required: true },
		type: { type: String, required: true },
		version: {
			validator: val => typeof val === "string" || val === null,
			required: true,
			default: null
		}
	},

	computed: {
		payload() {
			return {
				plan: this.plan,
				type: this.type,
				version: this.version
			}
		}
	},

	components: {
		DefaultProductDetail,
		ApeironProductDetail
	}
}
</script>
